import Vue from 'vue';

function currency(value) {
    let val = (value / 100).toFixed(2).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' €';
}

function decimalCurrency(value) {
    var formatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
    });

    return formatter.format(value);
}

Vue.filter('currency', currency);
Vue.filter('decimalCurrency', decimalCurrency)
